
export default {
  name: 'IconPersonBlack',
};
